<template>
  <div class="border rounded p-2 mt-4" style="position: relative;">
    <p class="legend">
      Current Notes
    </p>
    <div style="display: hidden; height: 15px;"></div>
    <template v-if="Notes"
      ><Note
        v-for="Note in Notes"
        :key="Note.notes_id"
        :headingContent="Note.title"
        :textAreaContent="Note.content"
        :note_id="Note.notes_id"
        :note_date="Note.note_date"
    /></template>
    <template v-else
      ><div
        class="border rounded mb-1 p-1 d-flex"
        style="width: 100%; background-color: #F9F9F9; min-height: 25vh; align-items:center; justify-content: center;"
      >
        <p class="text-center mb-0" style="color: black; font-size: 1rem;">
          No notes available
        </p>
      </div>
    </template>
  </div>
</template>

<script>
import Note from "./Note.vue";
export default {
  name: "CurrentNotes",
  components: {
    Note,
  },
  computed: {
    Notes() {
      return this.$store.state.orderDetails.CRMNotes;
    },
  },
  created() {
    this.$store.dispatch("orderDetails/getCRMNotes", {
      orderId: this.$route.query.order_id,
    });
  },
};
</script>

<style scoped>
.legend {
  color: black;
  position: absolute;
  top: -19px;
  left: 20px;
  background-color: white;
  display: inline;
  font-size: 1.3rem;
  font-weight: bold;
  padding: 0 5px;
  margin: 0;
}
</style>
